import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { GenerateCvService } from 'src/app/pages/generate resume/generate-cv-steps/services/generate-cv/generate-cv.service';
import { PaymentService } from 'src/app/services/payment/payment.service';

@Component({
  selector: 'app-scan-linkedin',
  templateUrl: './scan-linkedin.component.html',
  styleUrls: ['./scan-linkedin.component.css'],
})
export class ScanLinkedinComponent {
  services = [
    {
      color: 'blue',
      img: '../../../assets/icon/headline.svg',
      title: 'Headline',
      description: [
        'File format and size',
        'Resume length',
        'Long bullet points with suggestions on how to shorten',
      ],
    },
    {
      color: 'pink',
      img: '../../../assets/icon/summary.svg',
      title: 'Summary',
      description: [
        'Contact information',
        'Essential sections',
        'Personality showcase with tips on how to improve',
      ],
    },
    {
      color: 'blue',
      img: '../../../assets/icon/contact.svg',
      title: 'Contacts',
      description: [
        'ATS parse rate',
        'Repetition of words and phrases',
        'Spelling and grammar',
        'Quantifying impact in experience section with examples',
      ],
    },
    {
      color: 'pink',
      img: '../../../assets/icon/experience.png',
      title: 'Experience',
      description: ['Hard skills', 'Soft skills'],
    },
    {
      color: 'blue',
      img: '../../../assets/icon/educatiion.svg',
      title: 'Education',
      description: [
        'Resume design',
        'Email address',
        'Usage of active voice',
        'Usage of buzzwords and cliches',
      ],
    },
  ];

  steps: MenuItem[] = [];
  activeIndex: any = 0;
  linkedin: any;
  loading: boolean = false;
  jobTitle: string = '';
  objective: string = '';

  constructor(
    private translate: TranslateService,
    private cvService: GenerateCvService,
    private paymentService: PaymentService,
    private router: Router
  ) {
    this.getTranslate();
    this.translate.onLangChange.subscribe(() => {
      this.getTranslate();
    });
  }

  @ViewChild('stepsSection') stepsSection!: ElementRef;
    scrollToSteps() {
    if (this.stepsSection && this.stepsSection.nativeElement) {
      this.stepsSection.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  getTranslate() {
    this.translate
      .get(['Upload LinkedIn', 'Job Description', 'Result'])
      .subscribe((translations) => {
        this.steps = [
          { label: translations['Upload LinkedIn'] },
          { label: translations['Job Description'] },
          { label: translations['Result'] },
        ];
      });
  }

  onLinkedinDrop(event: any) {
    event.preventDefault();
    this.linkedin = event.dataTransfer.files[0];
    if (this.linkedin) {
      this.activeIndex = 1;
    }
  }

  onLinkedinSelected(event: any) {
    this.linkedin = event.target.files[0];
    if (this.linkedin) {
      this.activeIndex = 1;
      this.loading = true;
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  nextStep() {
    if (this.activeIndex === 1) {
      this.navigate();
    }
  }

  navigate() {
    this.router.navigate(['/scan-linkedin-result'], {
      state: {
        data: this.linkedin,
        jobTarget: this.jobTitle,
        jobDescription: this.objective,
        lang: this.translate.currentLang,
      },
    });
  }
}